import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  ForgotPasswordInput,
  ForgotPasswordResponse,
  forgotPasswordResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIForgotPassword = (
  options?: UseMutationOptions<
    ForgotPasswordResponse,
    ErrorResponse,
    ForgotPasswordInput
  >
) =>
  useMutation({
    mutationFn: (values) =>
      post(API_ENDPOINTS.FORGOT_PASSWORD, values, forgotPasswordResponseSchema),
    ...options,
  })
